import {
  FONT_SIZE_24,
  FONT_SIZE_14,
  FONT_SIZE_12,
  FONT_SIZE_10,
  FONT_SIZE_9,
  PRIMARY_TEXT,
  CATSKILL_WHITE,
  SUCCESS,
  DANGER,
  ATHENS_GRAY,
  SECONDARY_TEXT,
} from '../../../shared/pdf_styles';

const PdfStyles = {
  body: {
    color: PRIMARY_TEXT,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    color: PRIMARY_TEXT,
    fontSize: FONT_SIZE_24,
    textAlign: 'center',
  },
  image: {
    width: '24px',
    height: '24px',
    marginRight: 10,
  },
  subheader: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  invoiceID: {
    fontSize: FONT_SIZE_14,
    paddingBottom: 20,
    textTransform: 'uppercase',
  },
  invoiceDetails: {
    display: 'flex',
    flexDirection: 'row',
  },
  invoiceLabel: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.5,
  },
  invoiceToLabel: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.5,
    paddingBottom: 5,
    paddingRight: 65,
  },
  transactionForLabel: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.5,
    paddingBottom: 5,
    paddingRight: 57,
  },
  clientNameLabel: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.5,
    paddingBottom: 5,
    paddingRight: 55,
  },
  issueDateLabel: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.5,
    paddingBottom: 5,
    paddingRight: 62,
  },
  issuedByLabel: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.5,
    paddingBottom: 5,
    paddingRight: 65,
  },
  generatedByLabel: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.5,
    paddingBottom: 5,
    paddingRight: 48,
  },
  transactionMethodLabel: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.5,
    paddingBottom: 5,
    paddingRight: 22,
  },
  paidOnLabel: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.5,
    paddingBottom: 5,
    paddingRight: 73,
  },
  invoiceData: {
    fontSize: FONT_SIZE_10,
    lineHeight: 1.25,
    flex: 1,
  },
  payment: {
    position: 'absolute',
    fontSize: FONT_SIZE_10,
    bottom: 80,
    left: 35,
    right: 35,
    lineHeight: 1.5,
  },
  paymentDetails: {
    backgroundColor: CATSKILL_WHITE,
    fontSize: FONT_SIZE_10,
    padding: 20,
  },
  paymentInstruction: {
    paddingBottom: 5,
  },
  bankDetails: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  bankName: {
    marginRight: 8,
  },
  currencyInfo: {
    alignItems: 'flex-start',
    flexDirection: 'row',
  },
  table: {
    fontSize: FONT_SIZE_10,
    paddingTop: 20,
  },
  tableHeaderRow: {
    color: 'gray',
    display: 'flex',
    flexDirection: 'row',
    fontSize: FONT_SIZE_10,
    marginBottom: 8,
    justifyContent: 'space-between',
    borderBottom: 2,
    borderTop: 2,
    borderColor: ATHENS_GRAY,
  },
  tableDataLast: {
    flexDirection: 'end',
    paddingBottom: 5,
    paddingTop: 5,
    display: 'flex',
    justifyContent: 'space-between',
    textAlign: 'right',
    width: '25%',
  },
  tableDataFirst: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 5,
    paddingTop: 5,
    paddingLeft: 15,
    flex: '1',
    fontSize: FONT_SIZE_10,
    width: '25%',
  },
  tableDataSecond: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 5,
    paddingTop: 5,
    flex: '2',
    fontSize: FONT_SIZE_10,
    width: '50%',
  },
  tableDataRow: {
    flexDirection: 'row',
    marginBottom: 8,
    justifyContent: 'space-between',
    borderBottom: 2,
    borderColor: ATHENS_GRAY,
    paddingBottom: 5,
    alignItems: 'center',
  },
  tableDataFirstTopUp: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 5,
    paddingTop: 5,
    flex: '1',
    fontSize: FONT_SIZE_10,
    width: '25%',
  },
  tableDataTopUp: {
    paddingBottom: 5,
    paddingTop: 5,
    fontSize: FONT_SIZE_10,
  },
  referenceNumber: {
    paddingTop: 5,
    fontSize: FONT_SIZE_9,
    color: SECONDARY_TEXT,
  },
  tableDataLastAmount: {
    width: '25%',
    textAlign: 'right',
    flexDirection: 'end',
    paddingBottom: 5,
    paddingTop: 5,
    fontSize: FONT_SIZE_10,
  },
  tableSubTotalDataRow: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tableSubTotalData: {
    marginLeft: 350,
  },
  tableTotalDataRow: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 5,
    borderBottom: 2,
    borderColor: ATHENS_GRAY,
  },
  tableTotalData: {
    paddingLeft: 362,
    fontSize: FONT_SIZE_12,
    paddingTop: 5,
    paddingBottom: 10,
  },
  tableTotalAmount: {
    width: '25%',
    textAlign: 'right',
    flexDirection: 'end',
    paddingTop: 5,
    paddingBottom: 10,
    fontSize: FONT_SIZE_12,
  },
  line: {
    borderBottom: 2,
    borderColor: ATHENS_GRAY,
    width: '35%',
    marginLeft: 343,
  },
  description: {
    paddingTop: 10,
  },
  descriptionLabel: {
    fontSize: FONT_SIZE_12,
  },
  descriptionData: {
    paddingTop: 10,
    fontSize: FONT_SIZE_10,
  },
  linkContent: {
    color: PRIMARY_TEXT,
    padding: '6px',
  },
  updateDetailsHeader: {
    paddingTop: 5,
    fontSize: FONT_SIZE_12,
  },
  newBalanceData: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 5,
  },
  newBalanceLabel: {
    paddingLeft: 315,
    fontSize: FONT_SIZE_12,
    paddingBottom: 10,
  },
  newBalanceAmount: {
    width: '25%',
    textAlign: 'right',
    flexDirection: 'end',
    paddingBottom: 10,
    fontSize: FONT_SIZE_12,
  },
  tableDataLastAmountPositive: {
    width: '25%',
    textAlign: 'right',
    flexDirection: 'end',
    paddingBottom: 5,
    paddingTop: 5,
    fontSize: FONT_SIZE_10,
    color: SUCCESS,
  },
  tableDataLastAmountNegative: {
    width: '25%',
    textAlign: 'right',
    flexDirection: 'end',
    paddingBottom: 5,
    paddingTop: 5,
    fontSize: FONT_SIZE_10,
    color: DANGER,
  },
};

export default PdfStyles;
